import { render } from "./ModelsRange.vue?vue&type=template&id=fb4da1da"
import script from "./ModelsRange.vue?vue&type=script&lang=js"
export * from "./ModelsRange.vue?vue&type=script&lang=js"

import "./ModelsRange.vue?vue&type=style&index=0&id=fb4da1da&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__